exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#bottom-ad[data-v-6bda34ca]{background:#f8f8f8}#bottom-ad .bottom-banner[data-v-6bda34ca]{text-align:center;padding:24px 0}@media (max-width:767px){#bottom-ad .bottom-banner[data-v-6bda34ca]{padding:16px 0}}", ""]);

